import { Input } from '@base-ui/react/input'
import clsx from 'clsx'
import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

export function Textarea({ className, ...props }: TextareaProps) {
  // Base UI Input supports replacing the rendered element, but its props are typed for input
  // handlers. Cast textarea attrs at the boundary so consumers keep the native textarea API.
  const inputProps = props as unknown as InputHTMLAttributes<HTMLInputElement>

  return (
    <Input
      render={<textarea />}
      className={clsx(
        // Base styles
        'bg-white border border-gray-stroke w-full rounded-lg px-4 py-2 text-base outline-none transition-colors',
        'focus:ring-0 focus:border-lavender disabled:text-charcoal-50 disabled:cursor-not-allowed',
        'placeholder:text-charcoal-50 resize-y',
        // Invalid state styling using BaseUI data attributes
        'data-invalid:border-brick-light data-invalid:focus:border-brick-light',
        // Additional classes
        className
      )}
      {...inputProps}
    />
  )
}
